import { ROLES, CONFIGURATION_KEYS, TASKS_OVERVIEW } from 'constants/enums'

const tabs = [
  {
    id: 1,
    nameId: 'registration',
    label: 'Registration',
    intlKey: 'tabs.registration',
    path: '/registration-participants',
    counters: [TASKS_OVERVIEW.AWARD_REGISTRATION.id]
  },
  {
    id: 3,
    nameId: 'section_approval',
    label: 'Activity Approval',
    intlKey: 'tabs.activity_approval',
    path: '/section-approval',
    counters: [TASKS_OVERVIEW.SECTION_APPROVAL.id]
  },
  {
    id: 4,
    nameId: 'section_signoff',
    label: 'Section Signoff',
    intlKey: 'tabs.activity_signoff',
    path: '/section-signoff',
    counters: [TASKS_OVERVIEW.SECTION_SIGNOFF.id]
  },
  {
    id: 5,
    nameId: 'adventurous_journey',
    label: 'Adventurous Journey',
    intlKey: 'tabs.adventurous_journey',
    path: '/adventurous-journey',
    counters: [TASKS_OVERVIEW.AJ_SIGNOFF.id]
  },
  {
    id: 6,
    nameId: 'award_signoff',
    label: 'Award Signoff',
    intlKey: 'tabs.award_signoff',
    path: '/award-signoff',
    counters: [TASKS_OVERVIEW.AWARD_SIGNOFF.id]
  },
  {
    id: 7,
    nameId: 'unassigned_participants',
    label: 'Unassigned Participants',
    intlKey: 'tabs.unassigned_participants',
    path: '/unassigned-participants',
    counters: [TASKS_OVERVIEW.UNASSIGNED_PARTICIPANTS.id]
  },
  {
    // SHOW ONLY FOR AUSTRALIA
    id: 8,
    nameId: 'as_registration',
    label: 'Assessors',
    intlKey: 'tabs.assessors',
    path: '/assessors',
    configs: [CONFIGURATION_KEYS.manageAssessors.id],
    roles: [ROLES.ALL.u],
    counters: [TASKS_OVERVIEW.ASSESSOR_REGISTRATION.id]
  },
  {
    // SHOW ONLY FOR AUSTRALIA
    id: 9,
    nameId: 'as_cat_reg_registration',
    label: 'Assessors Activity',
    intlKey: 'tabs.assessors_activity',
    path: '/assessors-activity',
    configs: [CONFIGURATION_KEYS.manageAssessors.id],
    roles: [ROLES.ALL.u],
    counters: [TASKS_OVERVIEW.ASSESSOR_ACTIVITY_REGISTRATION.id]
  },
  {
    // SHOW ONLY FOR AUSTRALIA
    id: 10,
    nameId: 'as_wwc_update',
    label: 'WWC',
    intlKey: 'tabs.wwc_update',
    path: '/wwc-update',
    configs: [CONFIGURATION_KEYS.manageAssessors.id],
    roles: [ROLES.ALL.u],
    counters: [TASKS_OVERVIEW.ASSESSOR_WWC_UPDATE.id]
  },
  {
    id: 12,
    nameId: 'email_revision',
    label: 'Undelivered Emails',
    intlKey: 'pageTitle.tasks_undelivered_emails',
    path: '/email-revision',
    configs: [CONFIGURATION_KEYS.manageEmails.id],
    roles: [ROLES.ALL.u],
    counters: [TASKS_OVERVIEW.EMAIL_REVISION.id]
  }]

export default tabs
